import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { SessionStorage } from 'ngx-webstorage';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class ProjectsService {
  @SessionStorage() public user;
  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  /**API request to get project detail */
  getProjectList(pagenumber): Observable<any> {
    const data = {
      // 'pageSize': 5,
      // 'pageNumber': 1,
      'rmcode': this.user.Empno,
      // 'searchText': ''
    };
    return this.httpService.post(`project/rm/listFilter`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API request to get IPDO project list*/
  getIPDOProjectList(startDate, endDate): Observable<any> {
    return this.httpService.get(`project/ipdo/listFilter?startDate=${startDate}&endDate=${endDate}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API  to update project*/
  updateProject(data) {
    return this.httpService.put(`project`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API to search project*/
  searchFilter(searchTerm: string): Observable<any> {
    const data = {
      'searchText': searchTerm
    };
    return this.httpService.post(`project/search`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API request to delete project*/
  deleteProject(project: string, data: any): Observable<any> {
    return this.httpService.delete(`project/${project}/${data.userObj.Empname}/${data.userObj.Empno}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**Function to handle error data*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/projects/projects.service.ts